import { configureStore } from '@reduxjs/toolkit';

import api from './api';
import modal from './modal';

const redux = {
  api,
  modal,
  store: configureStore({
    devTools: true,
    middleware: (getDefaultMiddleware) => {
      return getDefaultMiddleware({
        serializableCheck: false,
      });
    },
    reducer: {
      api: api.reducer,
      modal: modal.reducer,
    },
  }),
};

export type RootState = ReturnType<typeof redux.store.getState>;

export default redux;
